import { Observable, of } from 'rxjs';

export function hasSaml2Authentication(): Observable<boolean> {
   return of(!showLocalFields());
}

export function showLocalFields(): boolean {
   const url = window.origin;
   const hostname = new URL(url).hostname; // Extracts the hostname
   const hostnameSplit = hostname.split('.');
   const subdomain = hostnameSplit[0].toLowerCase(); // Gets the first part of the hostname
   const adminPortal = hostnameSplit[1] && hostnameSplit[1].toLowerCase() === 'admin';
   const hasSaml2Authentication = subdomain === 'lcs' || adminPortal || url.indexOf('localhost:') > 0;
   return !hasSaml2Authentication;
}
